"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var index_1 = require("../../index");
var index_2 = require("../../../contexts/index");
var Utils_1 = require("./Utils");
var UseContainerDimensions_1 = require("../helpers/UseContainerDimensions");
var UseWindowDimension_1 = tslib_1.__importDefault(require("../helpers/UseWindowDimension"));
//const SelectedDropdownItem: React.FC<SingleValueProps> = (props) => {
var SelectedDropdownItem = function (_a) {
    var data = _a.data, componentWidth = _a.componentWidth, onTextHeightChange = _a.onTextHeightChange, displayMultiLineSelectedItem = _a.displayMultiLineSelectedItem, accountNoFontSize = _a.accountNoFontSize;
    var deemphasized = data.deemphasized;
    var responsiveSize = react_1.useContext(index_2.ResponsiveContext);
    var getMaxWidth = react_1.useCallback(function () {
        var maxDropdownWidth = componentWidth;
        var offsetWidth = 51 + 67 + 47;
        var maxTextWidth = maxDropdownWidth - offsetWidth;
        return maxTextWidth;
    }, [componentWidth]);
    var secondaryCompRef = react_1.useRef();
    var _b = UseContainerDimensions_1.UseContainerDimensions(secondaryCompRef), width = _b.width, height = _b.height;
    var windowsDimension = UseWindowDimension_1.default().width;
    var secondaryLabel = data.secondaryLabel, value = data.value;
    onTextHeightChange(height);
    var truncatedTxt = secondaryLabel.length <= getMaxWidth() / 8
        ? secondaryLabel
        : secondaryLabel.substring(0, getMaxWidth() / 8).concat('...');
    var secondaryLabelToDisplay = responsiveSize !== 'xs' ? (String(secondaryLabel).length > 40 ? truncatedTxt : secondaryLabel) : secondaryLabel;
    react_1.useEffect(function () {
        //
    }, [width, height, windowsDimension, getMaxWidth]);
    var displayMultilineForMobile = displayMultiLineSelectedItem && responsiveSize === 'xs';
    var defaultView = (react_1.default.createElement("div", { style: { display: 'flex', verticalAlign: 'middle', fontSize: '0.9em' } },
        react_1.default.createElement("span", { style: {
                verticalAlign: 'middle',
                textAlign: 'center',
                paddingTop: '6px',
                width: '52px'
            } }, data.icon),
        react_1.default.createElement(index_1.Text, { style: {
                fontWeight: 'bold',
                fontSize: '0.85em',
                marginTop: '6px',
                color: deemphasized ? '#757370' : ''
            } },
            data.value === 'link' ? '' : Utils_1.CapitaliseFirstLetter(data.label.toLowerCase()) + " : ",
            "\u00A0"),
        react_1.default.createElement(index_1.Text, { style: {
                fontSize: '0.85em',
                marginTop: '6px',
                marginRight: '4px',
                maxWidth: getMaxWidth() - 10,
                color: deemphasized ? '#757370' : '',
                overflow: 'hidden'
            } },
            react_1.default.createElement("div", { ref: secondaryCompRef }, secondaryLabelToDisplay.toUpperCase()))));
    var MobileViewMultiline = (react_1.default.createElement("div", { ref: secondaryCompRef },
        react_1.default.createElement("div", { style: { display: 'flex', verticalAlign: 'middle', fontSize: '0.9em', padding: '5px 0 5px 0' } },
            react_1.default.createElement("span", { style: {
                    verticalAlign: 'middle',
                    textAlign: 'center',
                    paddingTop: '10px',
                    width: '52px'
                } }, data.icon),
            react_1.default.createElement(index_1.Text, { size: "small", margin: { top: '6px' }, font: 'AvenirLTPro-Heavy', color: deemphasized ? '#3E3C3B' : '' },
                data.value === 'link' ? '' : Utils_1.CapitaliseFirstLetter(data.label.toLowerCase()) + " ",
                "\u00A0"),
            react_1.default.createElement("br", null)),
        react_1.default.createElement("div", { style: { display: 'flex', verticalAlign: 'top', fontSize: '0.9em', paddingLeft: '52px' } },
            react_1.default.createElement(index_1.Text, { size: '16px', margin: { right: '4px' }, color: deemphasized ? '#757370' : '', style: {
                    overflow: 'hidden',
                    position: 'relative',
                    top: '-15px',
                    lineHeight: '26px'
                } }, secondaryLabelToDisplay)),
        react_1.default.createElement("div", { style: { display: 'flex', verticalAlign: 'top', fontSize: '0.9em', paddingLeft: '52px' } },
            react_1.default.createElement(index_1.Text, { size: accountNoFontSize || '11px', margin: { right: '4px' }, color: deemphasized ? '#757370' : '', style: {
                    overflow: 'hidden',
                    position: 'relative',
                    top: '-12px',
                    paddingTop: '10px'
                } }, data.value === 'link' ? '' : "Account no: " + value))));
    return displayMultilineForMobile ? MobileViewMultiline : defaultView;
};
exports.default = SelectedDropdownItem;
//# sourceMappingURL=SelectedDropdownItem.js.map